import { useContext } from "react";
import {
  PageNewState,
  MemoEditDialogContext,
  MemoEditDialogInitialState,
} from ".";

export const useMemoEditDialogState = () => {
  const { pageState, setPageState } = useContext(MemoEditDialogContext);
  return [
    pageState,
    (newState: PageNewState) => setPageState(newState),
  ] as const;
};
